export const BuyData = [
  {
    label: 'Total investment',
    value: '$105.00',
  },
  {
    label: 'Platform fee',
    value: '$2.50',
  },
  {
    label: 'Transaction fee (1%)',
    value: '$1.05',
  },
  {
    label: 'Total purchase (USD)',
    value: '$108.55',
    isBold: true,
  },
];

export const SellData = [
  {
    label: 'Gross proceeds (USD)',
    value: ' $105.00',
  },
  {
    label: 'Platform fee',
    value: '$2.50',
  },
  {
    label: 'Transaction fee (1%)',
    value: '$1.05',
  },
  {
    label: 'Net proceeds',
    value: '$101.85',
    isBold: true,
  },
];

export const BuyReviewData = {
  title: 'Review buy order',
  details: [
    {
      label: 'shares',
      value: '10',
    },
    {
      label: 'Price per share',
      value: '$10.50',
    },
    {
      label: 'Total investment',
      value: '$105.00',
    },
    {
      label: 'Platform fee ',
      value: '$2.50',
    },
    {
      label: 'Total purchase (USD)',
      value: '$1.05',
    },
  ],
  choices: [
    {
      label: 'Total purchase (USD)',
      value: ' $108.55',
      isBold: true,
    },
    {
      label: 'Duration',
      tooltip: `'A “good until cancel” order is a buy or sell order that remains active until it is either executed or until the investor cancels it.

      A “good for the day” order is a buy or sell order that is only good for the remainder of the trading day on which it is placed. All “good for the day” orders will expire at 11:59 PM EST on the day they were placed.'`,
      value: 'Good until cancel',
    },
  ],
};

export const SellReviewData = {
  title: 'Review sell order',
  details: [
    {
      label: 'Shares',
      value: '10',
    },
    {
      label: 'Price per share',
      value: '$10.50',
    },
    {
      label: 'Gross proceeds (USD)',
      value: '$105.00',
    },
    {
      label: 'Platform fee',
      value: '$2.50',
    },
    {
      label: 'Transaction fee (1%)',
      value: '$1.05',
    },
  ],
  choices: [
    {
      label: 'Net proceeds (USD)',
      value: ' $101.85',
      isBold: true,
    },
    {
      label: 'Duration',
      tooltip: `'A “good until cancel” order is a buy or sell order that remains active until it is either executed or until the investor cancels it.

      A “good for the day” order is a buy or sell order that is only good for the remainder of the trading day on which it is placed. All “good for the day” orders will expire at 11:59 PM EST on the day they were placed.'`,
      value: 'Good until cancel',
    },
  ],
};

export const BuySuccessData = {
  title: 'You’ve made a buy order.',
  description:
    'You have successfully bid for 10 shares ($10.50 each) of The Carmichael. You will be notified through email about any progress made toward your bid.',
};

export const SellSuccessData = {
  title: 'You’ve placed a sell order.',
  description: 'You have successfully placed a sell order for 10 shares ($10.50 each) of The Cooper.',
};
